import { EyeOff, X } from 'lucide-react';

interface RemoveFlagPromptProps {
  title: string;
  cleanCount: number;
  playerLabel: string;
  busy: boolean;
  onRemove: () => void;
  onDismiss: () => void;
}

export function RemoveFlagPrompt({ title, cleanCount, playerLabel, busy, onRemove, onDismiss }: RemoveFlagPromptProps) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="remove-flag-prompt">
      <div className="bg-white dark:bg-gray-900 rounded-xl max-w-md w-full p-6 shadow-2xl">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-sky-100 dark:bg-sky-900/30 rounded-full flex items-center justify-center">
              <EyeOff className="w-5 h-5 text-sky-500" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Bridge recognizes this song now</h3>
          </div>
          <button onClick={onDismiss} className="p-1 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800" aria-label="Close">
            <X className="w-5 h-5" />
          </button>
        </div>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Bridge has now recognized <span className="font-semibold">{title}</span> {cleanCount} times in {playerLabel}.
          You can probably remove its &ldquo;Bridge didn&rsquo;t recognize&rdquo; flag.
        </p>
        <div className="flex gap-3">
          <button type="button" onClick={onDismiss} className="btn btn-secondary flex-1">
            Dismiss
          </button>
          <button type="button" onClick={onRemove} disabled={busy} className="btn btn-primary flex-1 disabled:opacity-50">
            Remove flag
          </button>
        </div>
      </div>
    </div>
  );
}
